"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupUiListener = void 0;
const models_1 = require("@creature-chess/models");
const ui_1 = require("~/store/game/ui");
const models_2 = require("@creature-chess/models");
const setupUiListener = (startListening) => {
    startListening({
        actionCreator: models_1.GameEvents.gamePhaseStartedEvent,
        effect: (_a, api_1) => __awaiter(void 0, [_a, api_1], void 0, function* ({ payload: { phase } }, api) {
            api.cancelActiveListeners();
            if (phase === models_2.GamePhase.PREPARING) {
                const accountId = api.extra.accountIdHolder.peek();
                const localPlayer = api.getState().game.players.find((p) => p.id === accountId);
                const isDead = (localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.health) === 0;
                if (!isDead) {
                    api.dispatch((0, ui_1.openOverlay)(ui_1.Overlay.SHOP));
                    return;
                }
            }
            if (phase === models_2.GamePhase.PREPARING || phase === models_2.GamePhase.READY) {
                api.dispatch((0, ui_1.closeOverlay)());
                api.dispatch((0, ui_1.clearSelectedPiece)());
            }
        }),
    });
};
exports.setupUiListener = setupUiListener;
